import { IWallet } from 'exchange-common'
import { BaseN } from '../models/baseN'
export class Utils {

	public static base256: BaseN = new BaseN()
	public static base62: BaseN = new BaseN('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz')
	public static base32: BaseN = new BaseN('0123456789ABCDEFGHKMNPQRSTUVWXYZ')

	public static timeSpan(start: string, rand?: string): number {
		let sec = 1000, min = 60 * sec, hour = 60 * min

		let toMsec = (ts?: string) => {
			if (!ts) { return 0 }
			let t: number = parseInt(ts)
			switch (true) {
				case ts.includes('sec') || ts.includes('s'):
					t *= sec
					break
				case ts.includes('min') || ts.includes('m'):
					t *= min
					break
				case ts.includes('hour') || ts.includes('h'):
					t *= hour
					break
				default:
					break
			}
			return t
		}

		return toMsec(start) + toMsec(rand) * Math.random()
	}

	public static hash(str: string) {
		let i, l, hval = 0x811c9dc5

		for (i = 0, l = str.length; i < l; i++) {
			hval ^= str.charCodeAt(i)
			hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24)
		}

		return this.zip(hval >>> 0, 4)
	}

	public static pad(str: string, size: number) {
		return (new Array(size + 1).join('0') + str).slice(-size)
	}

	public static chunk(str: string, size: number) {
		let chunks = new Array(str.length / size + .5 | 0),
			nChunks = chunks.length

		let newo = 0
		for (let i = 0, o = 0; i < nChunks; ++i, o = newo) {
			newo += size
			chunks[i] = str.substr(o, size)
		}

		return chunks
	}

	public static zip(num: number, size: number) {
		return (size) ? this.pad(this.base256.encode(num), size) : this.base256.encode(num)
	}

	public static unzip(str: string) {
		return this.base256.decode(str)
	}

	public static walletAmount(wallet: IWallet) {
		const dec = wallet.fiat ? 2 : 8
		const num = wallet.amount || 0
		let pow = Math.pow(10, dec)
		return (Math.round(num * pow) / pow).toFixed(dec)
	}
}


// WEBPACK FOOTER //
// ./src/functions/utils.ts